// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__4pIIb","isSelected":"Button_isSelected__tm8ZL"};